import React from "react";
import CertificateGenerator from "../components/CertificateGenerator";

const CertificatePage = () => {
  return <CertificateGenerator />;
};

export default CertificatePage;